const PolicyQueryKeys = {
  global: ["policies"] as const,
};

export { PolicyQueryKeys };
